import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import SimpleDate from "../../../../../modules/SimpleDate";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleTextArea from "../../../../../modules/simpleTextArea";
import {ACTIVITY_TYPE} from "../../../../common/Constants";

class MutasiBarangDetailInputs extends Component {
    handleValueChange = (name, value) => {
        if (name === 'mutationTargetKodeCabang') {
            this.props.onSetState((prevValue) => ({
                ...prevValue,
                firstLoad: false,
                data: {
                    ...prevValue.data,
                    [name]: value,
                },
            }));
        } else if(name==='mutationSourceKodeLocator'){
            this.props.onSetState((prevValue) => ({
                ...prevValue,
                data: {
                    ...prevValue.data,
                    mutationUnits:[],
                    mutationKsus: [],
                    [name]: value,
                },
            }));
        } else{
            this.props.onSetState((prevValue) => ({
                ...prevValue,
                data: {
                    ...prevValue.data,
                    [name]: value,
                },
            }));
        }
    };

    getDataValue = (fieldName, fallbackValue = "") => {
        return !R.isNil(this.props.state.data) && this.props.state.data[fieldName]
            ? this.props.state.data[fieldName]
            : fallbackValue;
    };

    readOnlyStatus = () => {
        if (this.props.mutasiKeluarTab) {
            return (!(this.props.state.data.mutationStatus === "NEW" || this.props.state.activityType === ACTIVITY_TYPE.CREATE) || this.props.buttonType == "delete" || this.props.buttonType == "preview");
        }

        return true;
    }

    render() {
        return (
            <>
                <div className="grid grid-3x grid-mobile-none gap-15px" style={{alignItems: "center"}}>
                    <div id="grid-1">
                        <SimpleInput
                            id="input_text_nomutasi"
                            name="mutationNo"
                            label="No. Mutasi"
                            readOnly
                            value={this.getDataValue("mutationNo")}
                        />
                        <FlexView style={{flexDirection: "column"}}>
                            <div className="txt-site txt-11 txt-main txt-bold">
                                <h4>Tgl. Mutasi</h4>
                            </div>
                            <SimpleDate
                                id="select_date_tgl_mutasi"
                                date={this.props.state.data.mutationDate}
                                disabled
                            />
                        </FlexView>
                    </div>
                    <div id="grid-2">
                        <SimpleDDL
                            id="select_options_cabang_asal"
                            name="mutationSourceKodeCabang"
                            label="Cabang Asal"
                            readOnly
                            box="search"
                            mandatory={this.props.mutasiKeluarTab}
                            value={this.getDataValue("mutationSourceKodeCabang", null)}
                        />
                        <SimpleDDL
                            id={
                                this.props.mutasiKeluarTab
                                    ? "select_options_cabang_tujuan"
                                    : "select_options_cabang_penerima"
                            }
                            name={"mutationTargetKodeCabang"}
                            label={this.props.mutasiKeluarTab ? "Cabang Tujuan" : "Cabang Penerima"}
                            mandatory={this.props.mutasiKeluarTab}
                            readOnly={this.readOnlyStatus()}
                            box="search"
                            options={this.props.state.cabangOptions}
                            value={this.getDataValue("mutationTargetKodeCabang", null)}
                            onChange={(value, {name}) => this.handleValueChange(name, value)}
                        />
                    </div>
                    <div id="grid-3">
                        <SimpleDDL
                            id="select_options_locator_asal"
                            name="mutationSourceKodeLocator"
                            label="Locator Asal"
                            mandatory={this.props.mutasiKeluarTab}
                            readOnly={this.readOnlyStatus()}
                            box="search"
                            options={this.props.state.locatorSourceOptions}
                            value={this.getDataValue("mutationSourceKodeLocator", null)}
                            onChange={(value, {name}) => this.handleValueChange(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_locator_tujuan"
                            name={"mutationTargetKodeLocator"}
                            errorMessage={this.props.state.errorData?.mutationTargetKodeLocator}
                            label={this.props.mutasiKeluarTab ? "Locator Tujuan" : "Locator Penerima"}
                            mandatory={!this.props.mutasiKeluarTab}
                            readOnly={
                                (this.props.mutasiKeluarTab) ?
                                (!(this.props.state.data.mutationStatus === "NEW" || this.props.state.activityType === ACTIVITY_TYPE.CREATE)) || this.props.buttonType == "delete" || this.props.buttonType == "preview" :
                                (!(this.props.state.data.mutationStatus === "PROCESSED" || this.props.state.activityType === ACTIVITY_TYPE.CREATE)) || this.props.buttonType == "delete" || this.props.buttonType == "preview"
                            }
                            box="search"
                            options={this.props.state.locatorTargetOptions}
                            isClearable
                            value={this.getDataValue("mutationTargetKodeLocator", null)}
                            onChange={(value, {name}) => this.handleValueChange(name, value)}
                        />
                    </div>
                </div>
                {!this.props.mutasiKeluarTab && (
                    <>
                        <SimpleTextArea
                            typeInputCase="normal"
                            name="mutationNote"
                            label="Catatan Penerimaan"
                            value={this.getDataValue("mutationNote")}
                            onChange={({target}) => this.handleValueChange(target.name, target.value)}
                        />
                        <FlexView
                            vAlignContent="center"
                            hAlignContent="right"
                            className="margin-top-5px margin-bottom-15px"
                            style={{gap: "10px"}}
                        >
                            <input
                                id="input_checkbox_penerimaan_bermasalah"
                                type="checkbox"
                                name="problem"
                                style={{height: "20px", width: "20px"}}
                                value={this.getDataValue("problem")}
                                onChange={({target}) => this.handleValueChange(target.name, target.checked)}
                            />
                            <div className="txt-site txt-11 txt-main txt-bold">
                                <h4>Penerimaan Bermasalah</h4>
                            </div>
                        </FlexView>
                    </>
                )}
            </>
        );
    }
}

export default MutasiBarangDetailInputs;
